import { Controller } from "@hotwired/stimulus"

// Composer of the combined site Verlauf. The "Fortschritt melden" link only makes sense once a
// task is picked as the target (a progress entry needs a task), so it is shown and pointed at
// that task's progression form when one is chosen. Photos go the other way: they are only
// posted onto the Baustelle itself — on a task they are a progress entry — so the picker hides
// and drops its selection while a task is the target.
export default class extends Controller {
  static targets = ["target", "progress", "progressLink", "photos", "files", "fileCount"]
  static values = { fileOne: String, fileOther: String }

  connect() {
    if (this.hasProgressLinkTarget)
      this.progressTemplate = this.progressLinkTarget.getAttribute("href")
    this.targetChanged()
  }

  targetChanged() {
    if (!this.hasTargetTarget) return

    const taskId = this.targetTarget.value
    this.togglePhotos(!taskId)
    if (!this.hasProgressTarget || !this.hasProgressLinkTarget) return

    this.progressTarget.classList.toggle("hidden", !taskId)
    if (taskId)
      this.progressLinkTarget.setAttribute(
        "href",
        this.progressTemplate.replace("__TASK__", encodeURIComponent(taskId)),
      )
  }

  filesChanged() {
    if (!this.hasFileCountTarget) return

    const count = this.filesTarget.files.length
    const label = count === 1 ? this.fileOneValue : this.fileOtherValue
    this.fileCountTarget.textContent = count > 0 ? label.replace("%{count}", count) : ""
  }

  togglePhotos(visible) {
    if (!this.hasPhotosTarget) return

    this.photosTarget.classList.toggle("hidden", !visible)
    if (visible || !this.hasFilesTarget) return

    this.filesTarget.value = ""
    this.filesChanged()
  }
}
